import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';

export default class FormatOdRateValueHelper extends Helper {
  @service('hotel-and-market') hotelAndMarketService;

  @service intl;

  // Helper currently used in the Overview dashboard for formatting of certain prices
  // Important that null results in '--'. Otherwise we want to see the currency symbol + formatted value.
  compute([value, useOverviewRevenueCurrency = false]) {
    if (isPresent(value)) {
      return this.hotelAndMarketService.formatRate(
        value,
        true,
        true,
        { maximumFractionDigits: 0, minimumFractionDigits: 0 },
        false,
        false,
        useOverviewRevenueCurrency,
      );
    }

    return this.intl.t('general.not_available_short');
  }
}
